import { render } from "./AddOrganisationDailyReportPosition.vue?vue&type=template&id=2d31acd2"
import script from "./AddOrganisationDailyReportPosition.vue?vue&type=script&lang=js"
export * from "./AddOrganisationDailyReportPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__